import { useHealthCheck } from '@/hooks/useHealthCheck';

export default function StatusPage() {
  const { data: health, loading, error } = useHealthCheck();

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h2 className="text-4xl font-bold text-gray-900">System Status</h2>
        <p className="mt-2 text-lg text-gray-600">
          Is it working? Let's find out.
        </p>
      </div>

      <div className="max-w-md mx-auto">
        <StatusCard loading={loading} error={error}>
          {health && (
            <div className="space-y-2">
              <StatusBadge label="Frontend" status={health.frontend.status} />
              {'error' in health.backend ? (
                <StatusBadge label="Backend" status={health.backend.error} />
              ) : (
                <>
                  <StatusBadge label="API" status={health.backend.status} />
                  <StatusBadge label="Database" status={health.backend.database} />
                </>
              )}
            </div>
          )}
        </StatusCard>
      </div>
    </div>
  );
}

function StatusCard({
  loading,
  error,
  children,
}: {
  loading: boolean;
  error: string | null;
  children: React.ReactNode;
}) {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      {loading ? (
        <div className="flex items-center gap-2 text-gray-500">
          <div className="w-4 h-4 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin" />
          <span className="text-sm">Checking...</span>
        </div>
      ) : error ? (
        <div className="text-sm text-red-600">{error}</div>
      ) : (
        children
      )}
    </div>
  );
}

function StatusBadge({ label, status }: { label: string; status: string }) {
  const isHealthy = status === 'healthy' || status === 'ok';
  return (
    <div className="flex items-center justify-between">
      <span className="text-sm text-gray-600">{label}</span>
      <span
        className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
          isHealthy ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
        }`}
      >
        {status}
      </span>
    </div>
  );
}
